import apolloClient from 'src/apollo/sofarApolloClient';

import { User } from 'app/shared/typings';

import { CREATE_CUSTOMER_LEAD } from './mutations';

export interface CreateCustomerLeadParameters {
  email: string;
  cityId?: number;
  closestSofarCityId?: number;
  sourceUrl: string;
}

export interface CreateCustomerLeadApiResponse {
  createCustomerLead: {
    customerLead: {
      email: string;
      cityId?: number;
      sourceUrl?: string;
    };
    user?: User;
  };
}

/**
 * This method calls the createCustomerLead endpoint on our api which will create
 * a customer lead entry for the email address to subscribe to the SofarSounds newsletter.
 */
export const CreateCustomerLead = async ({
  email,
  cityId,
  closestSofarCityId,
  sourceUrl,
}: {
  email: string;
  cityId?: string | number;
  closestSofarCityId?: number;
  sourceUrl: string;
}) => {
  return apolloClient.mutate<
    CreateCustomerLeadApiResponse,
    CreateCustomerLeadParameters
  >({
    mutation: CREATE_CUSTOMER_LEAD,
    variables: {
      email,
      sourceUrl,
      cityId: cityId ? Number(cityId) : undefined,
      closestSofarCityId,
    },
  });
};
